export var TypographyVariant;

(function (TypographyVariant) {
  TypographyVariant["DISPLAY_XL"] = "displayXL";
  TypographyVariant["DISPLAY_XL2"] = "displayXL2";
  TypographyVariant["DISPLAY_L"] = "displayL";
  TypographyVariant["DISPLAY_L2"] = "displayL2";
  TypographyVariant["DISPLAY_M"] = "displayM";
  TypographyVariant["DISPLAY_M2"] = "displayM2";
  TypographyVariant["DISPLAY_S"] = "displayS";
  TypographyVariant["DISPLAY_S2"] = "displayS2";
  TypographyVariant["HEADING"] = "heading";
  TypographyVariant["HEADING_2"] = "heading2";
  TypographyVariant["SUBHEADING"] = "subheading";
  TypographyVariant["SUBHEADING_2"] = "subheading2";
  TypographyVariant["BODY"] = "body";
  TypographyVariant["BODY_2"] = "body2";
  TypographyVariant["CAPTION"] = "caption";
  TypographyVariant["CAPTION_2"] = "caption2";
  TypographyVariant["OVERLINE"] = "overline";
  TypographyVariant["OVERLINE_2"] = "overline2";
})(TypographyVariant || (TypographyVariant = {}));